<template>
<div class="info">
	<div class="title">{{title}}
		<a class="title-a" v-if="from=='policy'&&info.insurancePolicyStatus=='UNDERWRITING'" @click="toEdit">参加人员编辑</a>
		<json-to-excel ref="jsonToExcel">
			<a class="title-a" v-if="from=='policy'" @click="excel">下载参加人员名单</a>
		</json-to-excel>
		<a class="title-a" v-if="from=='policy'" @click="toRecord">批改记录</a>
	</div>
	
	<Form :label-width="120" ref="form" class="mt15" v-if="from=='confirm'">
		<FormItem label="保障起期：" class="w600">{{info.effectiveDateStart}}</FormItem>
		<FormItem label="保障止期：" class="w600">{{info.effectiveDateEnd}}</FormItem>
		<FormItem label="保障天数：" class="w600">{{info.effectiveDays}}天</FormItem>
	</Form>
	<p class="recognize-total mt10">共{{list.length}}人</p>
	<div class="recognize-table mt10 pb20">
		<SchemeTable :type="isOld?'oldPerson':'person'" :quoteVersion="info.quoteVersion" />
		<e-table :list="list">
			<el-table-column prop="no" label="序号" width="70" align="center" fixed></el-table-column>
			<el-table-column prop="scheme" label="保障方案" show-overflow-tooltip min-width="180"></el-table-column>
			<el-table-column prop="premium" label="保费（元）" min-width="120"></el-table-column>
			<el-table-column prop="insuredPersonName" label="姓名" min-width="100"></el-table-column>
			<el-table-column prop="idCard" label="证件号码" min-width="190"></el-table-column>
			<el-table-column prop="gender" label="性别" min-width="70"></el-table-column>
			<el-table-column prop="age" label="年龄" min-width="70"></el-table-column>
			<el-table-column v-if="from=='policy'" prop="effectiveStatusDesc" label="保障状态" min-width="120"></el-table-column>
			<el-table-column v-if="from!='confirm'" prop="effectiveDateStart" label="保障起期" min-width="120"></el-table-column>
			<el-table-column v-if="from!='confirm'" prop="effectiveDateEnd" label="保障止期" min-width="120"></el-table-column>
			<el-table-column v-if="from!='confirm'" prop="remark" label="备注" show-overflow-tooltip min-width="160"></el-table-column>
		</e-table>
	</div>
	<Form :label-width="130" ref="form" v-if="fileList.length>0">
		<FormItem label="参加人员雇佣合同:" >
			<div class="upload-item" v-for="(item, index) in fileList" :key="index">
				<Icon type="ios-paper-outline" size="50" />
				<br>
				<a :href="item" target="_blank">点击下载</a><br>
			</div>
		</FormItem>
	</Form>
</div>
</template>
<script>
import SchemeTable from '../common/SchemeTable'
import JsonToExcel from '@/components/common/JsonToExcel'
import eTable from '@/components/common/eTable'
export default {
	components:{SchemeTable,JsonToExcel,eTable},
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		from:{
			type:String,
			default:'confirm'// confirm/order/policy
		},
		title:{
			type:String,
			default:'申请信息'
		}
	},
	data () {
		return {
			id:this.$route.params.id
		}
	},
	computed:{
	   days(){
			if(this.info.effectiveDateStart&&this.info.effectiveDateEnd){
				return this.getDays(this.formatDate(this.info.effectiveDateStart),this.formatDate(this.info.effectiveDateEnd));
			}else {
				return ""
			}
		},
		list(){
			return this.info.subjectMatter||[]
		},
		fileList(){
			return this.info.subjectMatterUrls?this.info.subjectMatterUrls.split(','):[]
		},
		isOld(){
			return this.info.createTime&&Date.parse(this.info.createTime)<Date.parse('2021/08/02 00:00:00')
		}
	},
	created() {
		
	},
	methods: {
		hideIdCard (str,frontLen=4,endLen=3) { 
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		toEdit () {
			this.$axios.post('/broker/insurance/endorse/preCheck',{
				insurancePolicyId:this.id
			}).then(res=>{
				this.$router.push(`/truck-employer/edit/person/${this.id}`)
			});
		},
		// 导出
		excel () {
			this.$refs.jsonToExcel.download({
				header:['序号','保障方案','保费（元）','姓名','证件号码','性别','年龄','保障起期','保障止期','备注'],
				props:['no','scheme','premium','insuredPersonName','idCard','gender','age','effectiveDateStart','effectiveDateEnd','remark'],
				data:this.list,
				fileName:this.info.productName+'参加人员名单'
			})
		},
		toRecord(){
			this.$router.push(`/truck-employer/edit-record/person/${this.id}`)
		}
	},
}
</script>
<style scoped lang="less">
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
	.upload-item{
		min-width: 90px;
		display: inline-block;
		text-align: center;
		margin-right: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/person/RecognizeInfo.vue